/**
 * manifest.js — ELYON-TMS-V2-B1-1 (Broker) + ELYON-TMS-V2-B2-1 (Shipper)
 *
 * TMS v2 module manifest consumed by the shell's ModuleLoader/AppRouter
 * (ELYON-SHELL-FOUNDATION-1). The shell builds routes from `screens[]` and
 * the sidebar entry from `icon` + `defaultRoute`.
 *
 * B1 (broker persona):
 *   - BrokerLoadBoard  (FLOOR-LOADBOARD-002 + DIFF-009 TMS-BID exception tab)
 *   - TenderWorkflow   (FLOOR-TENDER-001 + DIFF-009 parallel spot bid)
 *   - FinanceView      (FLOOR-FINANCE-001 dual AR/AP tracks)
 *
 * B2 (shipper persona — ELYON-TMS-V2-B2-1):
 *   - ShipperLoadBoard (FLOOR-LOADBOARD-001 + DIFF-010 map-as-tab + FLOOR-TRACK-001)
 *   - ShipmentDetail   (FLOOR-TRACK-001 predictive ETA + stops progress + live map)
 *
 * Enablement prereq: 'tms' in tenantConfig.enabled_modules.
 * @vite-ignore on screen components prevents TDZ circular-dep crash.
 */
export default {
  id: 'tms',
  label: 'TMS',
  icon: 'Truck',
  path: '/tms',
  defaultRoute: '/tms/loadboard',
  screens: [
    {
      path: '/tms/loadboard',
      component: () => import(/* @vite-ignore */ './screens/BrokerLoadBoard.jsx'),
      label: 'Load Board',
      icon: 'ClipboardList',
    },
    {
      path: '/tms/tender/:loadId',
      component: () => import(/* @vite-ignore */ './screens/TenderWorkflow.jsx'),
      label: 'Tender',
      icon: 'Send',
    },
    {
      path: '/tms/finance',
      component: () => import(/* @vite-ignore */ './screens/FinanceView.jsx'),
      label: 'Finance',
      icon: 'DollarSign',
    },
    // ── B2 Shipper persona (ELYON-TMS-V2-B2-1) ──
    {
      path: '/tms/shipments',
      component: () => import(/* @vite-ignore */ './screens/ShipperLoadBoard.jsx'),
      label: 'My Shipments',
      icon: 'Package',
    },
    {
      path: '/tms/shipment/:loadId',
      component: () => import(/* @vite-ignore */ './screens/ShipmentDetail.jsx'),
      label: 'Shipment Detail',
      icon: 'MapPin',
    },
    // ── ELYON-TMS-CONSOLIDATION-ENGINE-1 ──
    {
      path: '/tms/consolidation-engine',
      component: () => import(/* @vite-ignore */ './screens/ConsolidationEngine.jsx'),
      label: 'Consolidation Engine',
      icon: 'Layers',
    },
    {
      path: '/tms/consolidation',
      component: () => import(/* @vite-ignore */ './screens/Consolidation.jsx'),
      label: 'Consolidation',
      icon: 'Layers',
    },
    {
      path: '/tms/consolidation-opportunities',
      component: () => import(/* @vite-ignore */ './screens/ConsolidationOpportunities.jsx'),
      label: 'Consolidation Opportunities',
      icon: 'Layers',
    },
  ],
  requiredPermissions: [],
  substrate_consumers: ['DataService', 'EventBus', 'AEGIS'],
  contentCompletenessFloor: {
    description: 'Load Board must show ≥3 loads across ≥2 lifecycle states above fold at 1440×900',
    minLoadCount: 3,
    minStateCount: 2,
  },
};
